import { RouteConfig } from "@/router/types";
import PagesRoutes from "@/router/routes/pages";
import AdminRoutes from "@/router/routes/admin";
import VerifierRoutes from "@/router/routes/verifier";

export const routesConfig: RouteConfig[] = [
  ...PagesRoutes,
  ...AdminRoutes,
  ...VerifierRoutes,
  { path: "/", redirectTo: "/login" },
  { path: "*", redirectTo: "/login" },
];

export default routesConfig;
